import { render } from "./SketchPreview.vue?vue&type=template&id=2c924c06"
import script from "./SketchPreview.vue?vue&type=script&lang=js"
export * from "./SketchPreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__